<template>
  <div id="plotly">

  </div>
</template>

<script>

  // plotly
  import Plotly from 'plotly.js-dist';
  import locales from './locales/locale';
  import i18n from "@/i18n/i18n";

  let PlotlyLocale = locales[i18n.locale];

  export default {
    name: 'plotly',
    props: ['plotlyData'],
    data() {
      return {
        month: this.$t('feed.audit.involvement.body.month'),
        layout: {
          autosize: true,
          margin: {
            l: 50,
            r: 50,
            b: 0,
            t: 0,
            pad: 0
          },
          legend: {"orientation": "h"},
          xaxis: {
            autotick: false,
            ticks: 'outside',
            tick0: 0,
            dtick: 0.25,
            ticklen: 8,
            tickwidth: 1,
            tickcolor: '#ccc'
          },
        },
        config: {
          displayModeBar: true,
          displaylogo: false,
          modeBarButtons: [["zoom2d", "pan2d","zoomIn2d", "zoomOut2d", "autoScale2d"]],
        },
      }
    },
    methods: {
      getLabels() {
        let dateSeparator = "-";

        return this.plotlyData.graph_data.group1.graph.map(item => {
          if (item[0].includes(dateSeparator)) {
            let dateArr = item[0].split('-');
            let month = parseInt(dateArr[1]) - 1;

            return `${item[0].slice(-2)} ${this.month[month]}`;
          }

          return item[0];
        });
      },
      getData(group) {
        return this.plotlyData.graph_data[group].graph.map(item => {
          return item[1];
        });
      },
      getName(group) {
        if (this.plotlyData.graph_data[group].end === 1000) {
          return `${this.plotlyData.graph_data[group].start}+`;
        }
        if (`${this.plotlyData.graph_data[group].start} - ${this.plotlyData.graph_data[group].end}` === '0 - 0') {
          return 'Неизвестно';
        }
        return `${this.plotlyData.graph_data[group].start} - ${this.plotlyData.graph_data[group].end}`;
      },
      buildChart() {
        let plotDiv = document.getElementById('plotly');
        let traces = [
          {
            x: this.getLabels(),
            y: this.getData('group1'),
            stackgroup: 'one',
            name: this.getName('group1'),
            fillcolor: '#f75b5b',
            mode:'lines+markers',
            line: {
              color: '#f75b5b',
              shape: 'spline',
              smoothing: 1.3
            },
            marker: {
              color: '#f75b5b',
              size: 9,
            },
            groupnorm:'percent',
          },
          {
            x: this.getLabels(),
            y: this.getData('group2'),
            stackgroup: 'one',
            name: this.getName('group2'),
            fillcolor: '#b3bccc',
            mode:'lines+markers',
            line: {
              color: '#b3bccc',
              shape: 'spline',
              smoothing: 1.3,
            },
            marker: {
              color: '#b3bccc',
              size: 9,
            },
          },
          {
            x: this.getLabels(),
            y: this.getData('group3'),
            stackgroup: 'one',
            name: this.getName('group3'),
            fillcolor: '#ffc700',
            mode:'lines+markers',
            line: {
              color: '#ffc700',
              shape: 'spline',
              smoothing: 1.3
            },
            marker: {
              color: '#ffc700',
              size: 9,
            },
          },
          {
            x: this.getLabels(),
            y: this.getData('group4'),
            stackgroup: 'one',
            name: this.getName('group4'),
            fillcolor: '#5e6d82',
            mode:'lines+markers',
            line: {
              color: '#5e6d82',
              shape: 'spline',
              smoothing: 1.3
            },
            marker: {
              color: '#5e6d82',
              size: 9,
            },
          }
        ];

        Plotly.register(PlotlyLocale);
        Plotly.setPlotConfig({locale: i18n.locale});

        Plotly.newPlot(plotDiv, traces, this.layout, this.config);
      }
    },
    watch: {
      plotlyData(val) {
        if (val.graph_data) {
          this.buildChart();
        }
      }
    },
  };
</script>

<style>
  #plotly {
    width: 100%;
  }
</style>
